function createPolyfill(Class, property, value) {
	if (!Class.prototype[property]) Class.prototype[property] = value;
}

createPolyfill(Array, 'find', function (...args) {
	return this.filter(...args)[0];
});